export var ERR_REDIRECT = {
    message: "We're redirecting you to sign in to your account.",
};
export var ERR_UNABLE_TO_SAVE = {
    message: "We're unable to save your changes. Please try again.",
};
export var ERR_GENERIC = {
    message: 'Something went wrong. Please refresh the page and try again.',
};
export var ERR_ZIPCODE_FIND = {
    message: "We can't find this ZIP code. Please refresh the page and try again.",
};
export var ERR_NO_SAVED_ADR = {
    message: "You currently don't have any saved addresses.",
};
export var ERR_UNABLE_TO_SAVE_PAYMENT = {
    message: "We're unable to save your changes. Refresh the page and try again.",
};
export var ERR_INVALID_PAYMENT = {
    message: "We weren't able to save your changes. Review the card details and try again.",
};
export var DELETED_CITI_CARDS_ERROR_MSG1 = {
    message: 'We were unable to delete credit cards associated with Citi Account ID ****',
};
export var DELETED_CITI_CARDS_ERROR_MSG2 = {
    message: '. Please try again later.',
};
export var UNABLE_TO_COMPLETE_ERROR = {
    message: "We're unable to complete this action. Refresh the page and try again.",
};
